import React from 'react';
import { CircularProgress } from '@material-ui/core';


export default function CircularLoading(props) {

    const visible = props.visible;
    const color = props.color || "secondary";

    return (
        visible && <div style={{ display: "flex", width: "100%", height: "100%", justifyContent: "center", alignItems: "center" }}>
            <CircularProgress color={color} />
        </div>   
    );         
}

